import { Box, Button, Grid, Typography } from '@mui/material';
import ProgramFilter from '../../../../../components/filters/ProgramFilter';
import AddTypeModal from './components/AddTypeModal';
import ProgramTypesTable from './components/ProgramTypesTable';
import UpdateTypeModal from './components/UpdateTypeModal';
import { EMPTY_PAYLOAD } from './consts';
import { useProgramTypeContext } from './useProgramTypesContext';

const ProgramTypes = () => {
  const { setAddTypeModal, payload, setPayload } = useProgramTypeContext();
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        padding: 2,
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
      }}
    >
      <Grid
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <Typography variant="h6">Program Deliverable Types</Typography>
          <ProgramFilter
            programId={payload.id}
            handleChange={(id) => {
              if (id) {
                setPayload((prev) => ({ ...prev, id }));
              } else {
                setPayload(EMPTY_PAYLOAD);
              }
            }}
          />
        </Box>
        <Button
          variant="contained"
          size="small"
          onClick={() => setAddTypeModal(true)}
          sx={{ mb: 2, alignSelf: 'flex-end' }}
        >
          Add Type
        </Button>
      </Grid>

      <ProgramTypesTable />
      <AddTypeModal />
      <UpdateTypeModal />
    </Box>
  );
};

export default ProgramTypes;
